import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getSubcontractorRecordsData = async (
  projectId,
  fromDate,
  toDate,
  activeEmployerInfo
) => {
  const apiPath = `workflow/project/${projectId}/subcontractor-records/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
